<template>
  <page v-if="init">
    <div class="integral-container">
      <div class="content">
        <div class="header">
          <div class="explain" @click="handleGoRule">积分规则</div>
          <img :src="topImage" alt="" />
          <div class="detail">
            <div class="integral-wrapper" @click="handleJumpDetail">
              <span class="detail-icon" :class="gradeClass" />
              <div class="value">
                {{ score }}
                <div v-if="expireMsg && close" class="overdue">
                  <span class="text">{{ expireMsg }}</span>
                  <span
                    class="close iconfont icon-shanchu1"
                    @click.stop="handleCloseTip"
                  />
                  <div class="triangle" />
                </div>
              </div>
              <div class="integral-detial">
                积分
                <span class="arrow iconfont icon-arrow_right_l" />
              </div>
            </div>
            <div class="line" />
            <div class="grade-wrap">
              <span class="detail-icon detail-icon-integral" />
              <span class="gradeName" @click="goAllGood"> 下单赚积分 </span>
              <span class="arrow iconfont icon-arrow_right_l" />
            </div>
          </div>
        </div>
        <div
          v-if="integralTask.length || adPosition.length"
          class="module-wrapper ad-position"
        >
          <integral-task
            v-for="(item, index) in integralTask"
            :key="index"
            :activity="item"
            @recive="handleReciveTask"
          />
          <div class="im-list">
            <div
              v-for="item in adPosition"
              :key="item.position"
              class="position-img"
              @click="handlePositionClick(item)"
            >
              <img :src="item.imgUrl" alt="" />
            </div>
          </div>
        </div>
        <div
          v-if="isShowExchangeModule"
          id="integralExchange"
          class="module-wrapper"
        >
          <div class="title-wrapper">
            <div class="title-line">
              <h2 class="title">积分当钱花</h2>
              <div class="entry" @click="handleCheckHistory">
                已兑换
                <img class="arrow" src="@/images/integral/checkArrow.png" />
              </div>
            </div>
          </div>

          <div v-if="fullDiscountCoupons.length > 0" class="coupons-container">
            <div class="title-line">
              <img
                class="label-img"
                src="@/images/integral/fullDiscountCoupon.png"
              />
              满减券
            </div>
            <coupon-list
              :coupon-list="fullDiscountCoupons"
              @receiveCoupon="handleReceiveCoupon"
            />
          </div>

          <div v-if="shippingCoupons.length > 0" class="coupons-container">
            <div class="title-line">
              <img
                class="label-img"
                src="@/images/integral/shippingCoupon.png"
              />
              运费券
            </div>
            <coupon-list
              :coupon-list="shippingCoupons"
              type="shipping"
              @receiveCoupon="handleReceiveCoupon"
            />
          </div>

          <div v-if="serviceCoupons.length > 0" class="coupons-container">
            <div class="title-line">
              <img
                class="label-img"
                src="@/images/integral/serviceCoupon.png"
              />
              服务费券
            </div>
            <coupon-list
              :coupon-list="serviceCoupons"
              type="service"
              @receiveCoupon="handleReceiveCoupon"
            />
          </div>

          <div v-if="exchangeGoodsList.length > 0" class="title-wrapper">
            <div class="title-line">
              <h2 class="title">积分兑好礼</h2>
              <div class="entry" @click="handleCheckHistory">
                已兑换
                <img class="arrow" src="@/images/integral/checkArrow.png" />
              </div>
            </div>

            <p class="hint">
              商品兑换成功后将由专属VIP客服联系您兑现，您也可以主动联系您的专属VIP客服哦~
            </p>
          </div>

          <vue-flex-waterfall col="2" col-spacing="15" break-by-container>
            <ExchangeGoodCard
              v-for="item of computeExchangeGoodsList"
              :key="item.activityId"
              :item="item"
              @exchange="handleExchangeGood"
            />
          </vue-flex-waterfall>
          <div
            v-if="exchangeGoodsList.length > 4"
            class="footer"
            @click="showMoreExchangeGoods = !showMoreExchangeGoods"
          >
            <span class="txt">{{
              showMoreExchangeGoods ? '查看更多' : '收起'
            }}</span>
            <img
              src="@/images/arrow/arrow_bottom@3x.png"
              :class="['arrow', !showMoreExchangeGoods ? 'arrow-rotate' : '']"
            />
          </div>

          <goods-list
            :goods-list="goodsList"
            @pointGoodsExchange="onScoreGoodsExchange"
          />
        </div>
      </div>
    </div>
  </page>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import VueFlexWaterfall from 'vue-flex-waterfall'
import IntegralTask from './components/IntegralTask.vue'
import CouponList from './components/CouponList.vue'
import GoodsList from './components/GoodsList.vue'
import ExchangeGoodCard from './components/ExchangeGoodCard.vue'
import { nativeRedirect } from '@/utils/native_interactions/native_redirect'
import { nativeRoutes } from '@/utils/native_interactions/native_redirect/routes'
import { API } from '@/api'
import { navBar } from '@/utils/native_interactions/native_bar'
export default {
  name: 'MemberIntegral',
  components: {
    IntegralTask,
    CouponList,
    GoodsList,
    ExchangeGoodCard,
    VueFlexWaterfall
  },
  beforeRouteEnter(to, from, next) {
    next(v => {
      navBar.setTitle({
        text: '会员权益'
      })
      document.title = '会员权益'
      v.getPageInfo()
    })
  },
  data() {
    return {
      init: false,
      banner: {},
      expireMsg: '',
      close: true,
      topImage: '',
      mediumBusiness: false,

      fullDiscountCoupons: [],
      shippingCoupons: [],
      serviceCoupons: [],
      exchangeGoodsList: [],
      showMoreExchangeGoods: true,

      goodsList: [], // 可积分兑换商品列表
      integralTask: [], // 积分任务活动列表数据
      adPosition: [], // 积分任务广告位数据
      notice:
        '您有2022000积分将在2月1日0点失效清零，请您及时使用；活动有限，先到先得。'
    }
  },
  goBack() {
    this.$back()
  },
  computed: {
    ...mapState('integral', {
      gradeInfo: state => state.gradeInfo,
      ruleUrl: state => state.ruleUrl,
      score: state => state.score
    }),
    isMp() {
      return window.matrix.isMiniProgram
    },
    isShowExchangeModule() {
      return !!(
        this.shippingCoupons.length ||
        this.fullDiscountCoupons.length ||
        this.serviceCoupons.length ||
        this.goodsList.length
      )
    },
    gradeClass() {
      if (!this.gradeInfo.gradeId) return ''
      const gradeClass = ['bronze', 'silver', 'gold', 'platinum', 'diamond']
      return gradeClass[this.gradeInfo.gradeId - 1]
    },
    computeExchangeGoodsList() {
      if (this.exchangeGoodsList.length <= 4) return this.exchangeGoodsList
      return this.showMoreExchangeGoods
        ? this.exchangeGoodsList.slice(0, 4)
        : this.exchangeGoodsList
    }
  },

  methods: {
    ...mapActions('integral', [
      'exchangeGoods',
      'getScorePageInfo',
      'receiveCoupon',
      'scoreExchangeGoods'
    ]),
    // 跳转到全部菜品
    goAllGood() {
      this.$track(this.$trackMap.memberIntegral.SIGN_IN_BTN)
      nativeRedirect(nativeRoutes.goodsList)
    },
    async getPageInfo() {
      this.$Loading.show()
      try {
        const [baseInfo, companyInfo] = await Promise.all([
          this.getScorePageInfo(),
          API.memberIntegral.getCompanyInfo()
        ])
        const { banner, header, expireMsg, activityLink } = baseInfo
        this.banner = banner
        this.topImage = header
        this.expireMsg = expireMsg
        this.activityLink = activityLink
        // eslint-disable-next-line camelcase
        const { new_manage_type } = companyInfo
        this.mediumBusiness =
          Number(new_manage_type) === 200 || Number(new_manage_type) === 201
        this.init = true
      } catch (e) {
        console.log('e', e)
        this.$catch(e, { callback: () => this.goBack() })
      }
      this.$Loading.hide()

      this.close = true
      this.getScoreActivityTask() // 获取积分任务信息
      this.loadCouponsList() // 获取兑换券列表
      this.loadExchangeGoods() // 获取兑换实物
      this.loadScoreGoodsList() // 获取兑换商品列表
    },
    handleCloseTip() {
      this.close = false
    },
    handleJumpDetail() {
      this.$router.push({
        name: 'memberIntegralDetail'
      })
    },
    handlePositionClick(item) {
      this.$track(this.$trackMap.memberIntegral.TASK_POSITION_GO_ORDER)
      if (!item.h5Url) return
      this.$autoRedirect(item.h5Url)
    },
    // 跳转积分说明
    handleGoRule() {
      this.$track(this.$trackMap.memberIntegral.INTEGRAL_RULE)
      let url = 'https://material-page.yunshanmeicai.com/richText/1000425'
      if (this.mediumBusiness)
        url = 'https://material-page.yunshanmeicai.com/richText/1001059'
      this.$autoRedirect(url)
    },
    // 领取优惠券请求
    handleReceiveCoupon(coupon) {
      if (Number(this.score) < coupon.score) {
        this.$toast('您当前积分不足，快看看其他优惠券哦！')
      } else {
        this.$dialog
          .confirm({
            title: '温馨提示',
            message: `<div>当前剩余积分<span style="color: #0DAF52;"> ${this.score} </span>, 本次兑换将消耗<span style="color: red;">${coupon.score}</span>, 是否确定兑换?</div>`,
            cancelButtonText: '取消',
            cancelButtonColor: '#333',
            confirmButtonText: '确定'
          })
          .then(() => {
            this.receiveCoupon({
              activityId: coupon.activityId,
              actionId: coupon.actionId,
              sign: coupon.sign,
              score: coupon.score,
              receiveNum: 1
            })
              .then(() => {
                this.$toast('兑换成功！')
                this.$store.commit(
                  'integral/updateScore',
                  this.score - coupon.score
                )
                this.loadCouponsList()
              })
              .catch(err => {
                console.log(err)
                this.$toast(err.error.msg)
                this.loadCouponsList()
              })
          })
          .catch(() => {})
      }
    },
    async handleExchangeGood(item) {
      this.$track(this.$trackMap.memberIntegral.EXCHANGE_GOOD_GOODS)
      if (Number(this.score) < item.integral) {
        return this.$toast('您当前积分不足，快看看其他好礼哦！')
      }
      this.$dialog
        .confirm({
          title: '温馨提示',
          message: `<div>当前剩余积分${this.score}，本次兑换将消耗${item.integral}，是否确认兑换？</div>`,
          cancelButtonText: '取消',
          cancelButtonColor: '#333',
          confirmButtonText: '确定'
        })
        .then(() => {
          API.memberIntegral
            .exchangeGoods({
              actionId: item.actionId,
              activityId: item.activityId
            })
            .then(() => {
              this.$dialog.alert({ message: '兑换成功' })
              this.$store.commit(
                'integral/updateScore',
                this.score - item.integral
              )
              this.loadExchangeGoods()
            })
            .catch(e => {
              this.$catch(e)
            })
        })
        .catch(() => {})
    },
    /**
     * 执行单个商品积分兑换
     */
    onScoreGoodsExchange(goodsItem) {
      this.$track(this.$trackMap.memberIntegral.EXCHANGE_GOODS, {
        ssu_id: goodsItem.ssuId,
        ssu_name: goodsItem.goodName
      })
      if (Number(this.score) < goodsItem.score) {
        this.$toast('您当前积分不足，快看看其他商品哦！')
      } else {
        this.$dialog
          .confirm({
            title: '温馨提示',
            message: `<div>积分兑换后不支持退还，确认要使用 <span style="color: red;">${goodsItem.score}</span> 积分兑换吗?</div>`,
            cancelButtonText: '取消',
            cancelButtonColor: '#333',
            confirmButtonText: '确定'
          })
          .then(() => {
            this.scoreExchangeGoods({
              ssuId: goodsItem.ssuId
            })
              .then(data => {
                if (!data || !data.result) {
                  this.$toast(
                    data && data.errorMsg ? data.errorMsg : '兑换失败！'
                  )
                  return
                }
                this.$dialog.alert({
                  title: '兑换成功！',
                  message: '商品已经加入购物车，有效期30天，请您尽快带走哦~'
                })
                this.$store.commit(
                  'integral/updateScore',
                  this.score - goodsItem.score
                )
                this.loadScoreGoodsList()
              })
              .catch(err => {
                this.$catch(err)
              })
          })
          .catch(() => {})
      }
    },

    /**
     * 获得优惠劵列表
     */
    async loadCouponsList() {
      try {
        const res = await API.memberIntegral.queryScoreCouponActivity()
        const shippingCoupons = []
        const fullDiscountCoupons = []
        const serviceCoupons = []
        for (const item of res) {
          const { couponList } = item
          if (Array.isArray(couponList) && couponList.length > 0) {
            const coupon = couponList[0]
            const {
              canBuyNum,
              triggerCount,
              actionId,
              activityId,
              sign,
              leftNum
            } = item
            const { couponType } = coupon
            let status = 0
            if (canBuyNum > 0 && triggerCount >= 0) {
              status = 1
            } else if (canBuyNum === 0 && triggerCount > 0) {
              status = 2
            } else if (canBuyNum === 0 && triggerCount === 0) {
              status = 3
            }
            const obj = {
              ...coupon,
              status,
              canBuyNum,
              triggerCount,
              actionId,
              activityId,
              sign,
              leftNum
            }
            if (couponType === 1) fullDiscountCoupons.push(obj)
            if (couponType === 7) shippingCoupons.push(obj)
            if (couponType === 8) serviceCoupons.push(obj)
          }
        }
        this.fullDiscountCoupons = fullDiscountCoupons
        this.shippingCoupons = shippingCoupons
        this.serviceCoupons = serviceCoupons
      } catch (err) {
        console.log(err)
      }
    },
    async loadExchangeGoods() {
      try {
        const res = await API.memberIntegral.queryScoreExchangeGoodsActivity()
        const exchangeGoodsList = []
        for (const item of res) {
          const { goodsList } = item
          if (Array.isArray(goodsList) && goodsList.length > 0) {
            const good = goodsList[0]
            const {
              totalLimit,
              canBuyNum,
              triggerCount,
              actionId,
              activityId
            } = item
            if (canBuyNum === 0) continue
            exchangeGoodsList.push({
              ...good,
              totalLimit,
              canBuyNum,
              triggerCount,
              actionId,
              activityId
            })
          }
        }
        this.exchangeGoodsList = exchangeGoodsList
      } catch (err) {
        console.log(err)
      }
    },

    /**
     * 获得积分兑换商品列表
     */
    async loadScoreGoodsList() {
      try {
        const res = await API.memberIntegral.getScoreExchangeGoodsList()
        this.goodsList = res.ssuItems || []
      } catch (e) {
        this.goodsList = []
      }
    },
    async getScoreActivityTask() {
      try {
        const res = await API.memberIntegral.getScoreActivityTask()
        this.integralTask = res.integralTask
        this.adPosition = res.adPosition
      } catch (e) {
        this.$catch(e)
      }
    },
    async handleReciveTask(params) {
      this.$track(this.$trackMap.memberIntegral.TASK_RECEIVE_CLICK)
      try {
        await API.memberIntegral.receiveIntegralTask(params)
        this.$toast('任务领取成功')
        this.getScoreActivityTask()
      } catch (e) {
        this.$catch(e)
      }
    },
    handleCheckHistory() {
      this.$track(this.$trackMap.memberIntegral.EXCHANGE_LIST)
      this.$router.push({ name: 'memberIntegralHistory' })
    }
  }
}
</script>
<style lang="scss" scoped>
.integral-container {
  position: relative;
  background-color: rgb(255, 249, 242);
  height: 100%;
  overflow-y: scroll;
  .content {
    position: relative;
    padding-bottom: 40px;
    min-height: 100%;
    box-sizing: border-box;
  }
}
.header {
  position: relative;
  margin-bottom: 0.56rem;
  width: 100%;
  padding-bottom: 48%;
  .explain {
    position: absolute;
    top: 0;
    right: 0;
    padding: 0.2rem;
    color: #fff;
    font-size: 0.24rem;
    z-index: 10;
  }
  img {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
  }
  .detail {
    position: absolute;
    left: 0.3rem;
    right: 0.3rem;
    bottom: -0.44rem;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 1.3rem;
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0px 3px 6px 0px rgba(85, 63, 32, 0.08);
    .line {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 1px;
      height: 0.34rem;
      background-color: rgba(99, 75, 59, 0.3);
    }
    .detail-icon {
      width: 0.4rem;
      height: 0.4rem;
      transform: translateY(0.04rem);
      background-size: 100% 100%;
      &.bronze {
        background-image: url('~@/images/level/bronze.png');
      }
      &.silver {
        background-image: url('~@/images/level/silver.png');
      }
      &.gold {
        background-image: url('~@/images/level/gold.png');
      }
      &.platinum {
        background-image: url('~@/images/level/platinum.png');
      }
      &.diamond {
        background-image: url('~@/images/level/diamond.png');
      }

      &.detail-icon-integral {
        transform: translateY(0);
        background-image: url('~@/images/integral/integral_bg@3x.png');
      }
    }
    .grade-wrap {
      width: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #333;
      font-size: 0.32rem;
      font-weight: 500;
      .gradeName {
        position: relative;
        margin: 0 0 0 0.08rem;
        & > .tip {
          position: absolute;
          top: -0.28rem;
          right: -0.5rem;
          width: 1rem;
          height: 0.28rem;
          line-height: 0.28rem;
          text-align: center;
          font-size: 0.2rem;
          color: #fff;
          border-radius: 0.14rem 0.14rem 0.14rem 0;
          background-image: linear-gradient(to right, #ff7d5e 0%, #ff3410 100%);
          box-shadow: 0px 6px 15px -5px rgba(255, 80, 45, 0.5);
        }
      }
      .arrow {
        margin-top: 0.04rem;
        font-size: 0.2rem;
        font-weight: 800;
        color: #666;
        transform: scale(0.7);
      }
    }
    .integral-wrapper {
      width: 50%;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: baseline;
      .value {
        position: relative;
        margin: 0 0.12rem 0 0.08rem;
        margin-right: 0.12rem;
        font-weight: 600;
        font-size: 0.4rem;
        line-height: 0.4rem;
        color: #333;
      }
      .integral-detial {
        display: flex;
        align-items: center;
        font-size: 0.22rem;
        font-weight: 900;
        color: #666;
        .arrow {
          margin-top: 0.05rem;
          font-size: 0.2rem;
          font-weight: 800;
          transform: scale(0.7);
        }
      }
      .overdue {
        position: absolute;
        display: flex;
        flex-wrap: nowrap;
        border-radius: 0.08rem;
        background-color: #666666;
        left: 0%;
        bottom: -140%;
        line-height: 0.2rem;
        align-items: center;
        .text {
          height: 0.48rem;
          padding-left: 0.22rem;
          display: flex;
          align-items: center;
          color: #fff;
          font-size: 0.2rem;
          white-space: nowrap;
        }
        .close {
          padding: 0.12rem 0.22rem;
          font-size: 0.2rem;
          color: #fff;
        }
        .triangle {
          position: absolute;
          left: 0.3rem;
          top: -8px;
          width: 0;
          height: 0;
          border: 4px solid transparent;
          border-bottom: 4px solid #666666;
        }
      }
    }
  }
}
.message {
  padding-top: 0.3rem;
}
.module-wrapper {
  padding: 0 0.3rem;
  &.ad-position {
    padding-top: 0.1rem;
  }
  .title-wrapper {
    padding: 15px 0;
    .title-line {
      display: flex;
      flex-direction: row;
      .title {
        color: #333;
        font-size: 0.4rem;
        font-weight: 900;
        line-height: 30px;
        flex: 1;
      }

      .entry {
        color: #ff5c00;
        font-size: 13px;
        & > .arrow {
          width: 5px;
          margin-left: 2px;
        }
      }
    }
    .sub-title {
      margin-left: 0.2rem;
      color: #999;
      font-size: 0.28rem;
      font-weight: 400;
    }
    .hint {
      font-size: 12px;
      color: #333;
      margin-top: 15px;
    }
  }
  .exchange-goods-list {
    column-count: 2;
    column-gap: 13px;
  }
  .position-img {
    margin-bottom: 0.24rem;
    box-shadow: 0px 2px 10px 0px rgba(85, 63, 32, 0.1);
    border-radius: 0.12rem;
    font-size: 0;
    img {
      width: 100%;
      height: 100%;
    }
  }

  & > .coupons-container {
    & > .title-line {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 13px;
      font-size: 14px;
      color: #333;
      height: 20px;

      & > .label-img {
        width: 18px;
        margin-right: 8px;
      }
    }
  }
}
.foot-btn {
  position: absolute;
  bottom: 0;
  width: 100%;
  @include flex-row-center;
  height: 0.96rem;
  font-size: 0.36rem;
  font-weight: bold;
  color: #333;
  background-color: #fff;
  box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.1);
  .arrow {
    margin-left: 0.1rem;
    color: #999;
    font-size: 0.24rem;
  }
}

.model-content {
  position: relative;
  width: 5.6rem;
  background-repeat: no-repeat;
  background-size: cover;
  text-align: center;
  color: #fff;
  &.signing-in {
    height: 7rem;
    background-image: url('~@/images/integral/model_bg1.png');
    .title {
      padding-top: 0.52rem;
      font-size: 0.4rem;
    }
    .sub-title {
      font-size: 0.7rem;
    }
    .btn {
      width: 3.6rem;
      background-image: url('~@/images/integral/sign_in_btn_bg.png');
    }
  }
  &.receive-rewards {
    height: 7.6rem;
    background-image: url('~@/images/integral/receive_rewards_bg.png');
    .title {
      padding-top: 3.6rem;
      font-size: 0.4rem;
      color: #666;
    }
    .sub-title {
      margin-top: 0.1rem;
      font-size: 0.7rem;
      color: #333;
    }
    .btn {
      width: 4.48rem;
      background-image: url('~@/images/integral/sign_btn_bg.png');
    }
  }
  &.signed-in {
    height: 7.6rem;
    background-image: url('~@/images/integral/signed_in_bg.png');
    .title {
      padding-top: 3.6rem;
      font-size: 0.4rem;
      color: #333;
    }
    .sub-title {
      margin-top: 0.1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ff6139;
      font-size: 0.8rem;
      span {
        font-size: 0.64rem;
        font-weight: 600;
      }
    }
    .btn {
      width: 4.48rem;
      background-image: url('~@/images/integral/sign_btn_bg.png');
    }
  }
  .btn {
    position: absolute;
    left: 50%;
    bottom: 0.4rem;
    transform: translateX(-50%);
    height: 1.52rem;
    line-height: 1.52rem;
    font-size: 0.4rem;
    background-repeat: no-repeat;
    background-size: cover;
  }
}

.footer {
  @include flex-row-center;
  margin: 0.4rem 0 0;
  .txt {
    font-size: 0.24rem;
    color: #999999;
    text-align: center;
  }
  .arrow {
    width: 0.2rem;
    height: 0.15rem;
    margin-left: 0.1rem;
    vertical-align: middle;
  }
  .arrow-rotate {
    transform: rotate(180deg);
  }
}
</style>
